module.exports={
    "name": "web3",
    "version": "1.2.6",
    "description": "Ethereum JavaScript API",
    "repository": "https://github.com/ethereum/web3.js",
    "license": "LGPL-3.0",
    "engines": {
        "node": ">=8.0.0"
    },
    "main": "src/index.js",
    "bugs": {
        "url": "https://github.com/ethereum/web3.js/issues"
    },
    "keywords": [
        "Ethereum",
        "JavaScript",
        "API"
    ],
    "author": "ethereum.org",
    "types": "types/index.d.ts",
    "scripts": {
        "dtslint": "dtslint types --onlyTestTsNext",
        "postinstall": "node angular-patch.js"
    },
    "authors": [
        {
            "name": "Fabian Vogelsteller",
            "email": "fabian@ethereum.org",
            "homepage": "http://frozeman.de"
        },
        {
            "name": "Marek Kotewicz",
            "email": "marek@parity.io",
            "url": "https://github.com/debris"
        },
        {
            "name": "Marian Oancea",
            "url": "https://github.com/cubedro"
        },
        {
            "name": "Gav Wood",
            "email": "g@parity.io",
            "homepage": "http://gavwood.com"
        },
        {
            "name": "Jeffery Wilcke",
            "email": "jeffrey.wilcke@ethereum.org",
            "url": "https://github.com/obscuren"
        }
    ],
    "dependencies": {
        "@types/node": "^12.6.1",
        "web3-bzz": "1.2.5",
        "web3-core": "1.2.5",
        "web3-eth": "1.2.5",
        "web3-eth-personal": "1.2.5",
        "web3-net": "1.2.5",
        "web3-shh": "1.2.5",
        "web3-utils": "1.2.5"
    },
    "devDependencies": {
        "definitelytyped-header-parser": "^1.0.1",
        "dtslint": "0.4.2"
    }
}
